module.exports = __webpack_public_path__ + "img/logo.fed970b1.png";